// extracted by mini-css-extract-plugin
export default {"timerControl":"TimerView_timerControl__smu8A","timerIcon":"TimerView_timerIcon__6uZ1D"};